import { alpha, CSSVariablesResolver, darken } from "@mantine/core"

export const CSSresolver: CSSVariablesResolver = (theme) => {
  return {
    variables: {
      "--mantine-brand-navbar-width": "50px",
      "--mantine-brand-header-height": "3rem",
      "--mantine-supplier-header-height": "3rem",
      "--tfg-layout-padding-x": theme.spacing.lg,
      "--tfg-layout-padding-y": theme.spacing.md,
      "--tfg-card-border-radius": theme.radius.md,
      "--tfg-organism-padding-x": theme.spacing.md,
      "--tfg-organism-padding-y": theme.spacing.sm,
      "--tfg-molecule-padding-x": theme.spacing.sm,
      "--tfg-molecule-padding-y": theme.spacing.xs,
      "--tfg-bg-color-warning": theme.colors.orange[4],
      "--tfg-bg-color-success": "rgba(212, 223, 218, 1)",
      "--tfg-bg-color-notice": "rgba(215, 224, 250, 1)",
      "--tfg-text-color-secondary": theme.colors.ground[8],
      "--mantine-color-white": "#FFFFFF",
      "--table-header-text-size": theme.fontSizes.xs,
      "--table-header-text-weight": "600",
      "--table-cell-text-size": theme.fontSizes.xs,
      "--navbar-item-height": "60px",
      "--table-height": "70vh",
    },
    light: {
      "--mantine-color-text-color": "#1F1C19",
      "--mantine-color-text": "#1F1C19",
      "--dawn-linear-gradient":
        "linear-gradient(106.49deg, #FAF4E5 19.55%, #ABBCCD 76.09%)",
      "--nude-linear-gradient":
        "linear-gradient(106.49deg, #FAF4E5 19.55%, #F4E4D1 76.09%)",
      "--sunset-linear-gradient":
        "linear-gradient(106.49deg, #FAEAE5 19.55%, #C0D0E0 76.09%)",
      "--mantine-color-dimmed": alpha(theme.colors.walnut[8], 0.6),
      "--mantine-color-supplier-header-text": "var(--mantine-color-text)",
      "--mantine-color-supplier-background":
        "var(--mantine-color-brand-background)",
      "--mantine-color-supplier-header-bg": "var(--mantine-color-white)",
      "--mantine-color-brand-header-bg": theme.colors.gray[0],
      "--mantine-color-brand-header-text": "var(--mantine-color-text-color)",
      "--mantine-color-brand-background": "#FCFBFA",
      "--mantine-color-body": "var(--mantine-color-brand-background)",
      "--mantine-color-error": "#FC4315",
      "--mantine-color-error-text": theme.colors.red[9],
      "--mantine-color-success": theme.colors.green[9],
      "--mantine-color-warning": "#F58300",
      "--tag-color-info": theme.colors.walnut[8],
      "--icon-info-color": theme.colors.walnut[8],
      "--tag-color-seashell": "#FAEAE5",
      "--tag-color-peach": "FFE1BD",
      "--tag-color-powder-blue": "#ABBCCD",
      "--sidebar-color": theme.colors.secondary[9],
      "--primary-disabled-color": "rgba(70, 121, 255, 0.4)",
      "--secondary-disabled-color": "rgba(255, 255, 255, 0.4)",
      "--table-header-color": "#E2DBD5",
      "--table-line-hover-color": "#faf9f7",
      "--input-border-color": theme.colors.gray[2],
      "--input-text-color": "var(--mantine-color-text)",
      "--progress-bar-color-filled": darken(theme.colors.primary[4], 0.1),
      "--progress-bar-filled-text": "var(--mantine-color-white)",
      "--progress-bar-color-unfilled": theme.colors.gray[1],
      "--progress-bar-unfilled-text": "var(--mantine-color-text)",
      "--mantine-color-success-text": darken(theme.colors.green[9], 0.3),
    },
    dark: {},
  }
}
